import React, {useMemo} from "react";
import { EuiButton } from '@elastic/eui';
import './styles.css'

export const LinkDrillDown = (props:any) => {
const {params, onClickDrillDown, dataOption, drillAll} = props

  if (params.node.rowPinned &&(drillAll!==undefined && drillAll===false)) {
    return null;
  }

  return <EuiButton className='drilldownbtn' fullWidth fill size='s' onClick={()=>onClickDrillDown && onClickDrillDown(params.data[dataOption])}>{params.value}</EuiButton>
};